import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Query } from 'react-apollo';

import { Messages } from '../../../gen-src/Localize';
import { VirtualConnectionTableQuery, VirtualConnectionTableQuery_virtualConnectionTables, VirtualConnectionTableQueryVariables } from '../../../gen-src/queries/VirtualConnectionTableQuery';
import { VirtualConnectionTableQueryGql } from '../../queries/VirtualConnectionTableQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type VirtualConnectionTableQueryWrapperProps = {
  readonly vizportalUrlId: string;
  readonly children: (result: VirtualConnectionTableQuery_virtualConnectionTables) => React.ReactNode;
};

export class VirtualConnectionTableQueryWrapper extends React.Component<VirtualConnectionTableQueryWrapperProps> {

  public render(): React.ReactNode {
    return (
      <Query<VirtualConnectionTableQuery, VirtualConnectionTableQueryVariables>
        query={VirtualConnectionTableQueryGql}
        variables={{ vizportalUrlId: this.props.vizportalUrlId }}
      >
        {result => renderQueryResult(result, {
          renderLoading: () => <CenteredFadeInSpinner />,
          renderData: this.renderVirtualConnectionTableData,
          renderNoData: renderNoData,
          renderDataWithError: createRenderDataWithErrorFunction(this.renderVirtualConnectionTableData),
          renderError: renderError,
        })}
      </Query>
    );
  }

  private readonly renderVirtualConnectionTableData = (data: VirtualConnectionTableQuery): React.ReactNode => {
    const virtualConnectionTable = data.virtualConnectionTables ? data.virtualConnectionTables[0] : null;
    if (virtualConnectionTable) {
      return this.props.children(virtualConnectionTable);
    } else {
      return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
    }
  }

}
